export default "__VITE_ASSET__c630cf61__"